export default "__VITE_ASSET__DZPfhOol__"